
import { Component, Directive, Input } from "@angular/core";
import { NavController } from 'ionic-angular';

import { DashboardActivityPage } from '../../pages/dashboard/activity/dashboard-activity';
import { DashboardExercisePage } from '../../pages/dashboard/exercise/dashboard-exercise';
import { DashboardNutritionPage } from '../../pages/dashboard/nutrition/dashboard-nutrition';

@Component({
  selector: 'dashboard-tabs',
  templateUrl: 'dashboard-tabs.html',
})
@Directive({
  selector: "dashboard-tabs"
})
export class DashboardTabs {  
  @Input('page') page: string;

  constructor(
    private navCtrl: NavController) {
  }

  doOpenPage() {
    switch(this.page) {
      case 'nutrition':
        this.navCtrl.setRoot(DashboardNutritionPage);
        break;
      case 'activity':
        this.navCtrl.setRoot(DashboardActivityPage);
        break;
      case 'exercise':
        this.navCtrl.setRoot(DashboardExercisePage);
        break;
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/dashboard-tabs/dashboard-tabs.ts